import * as Yup from 'yup'
import {BaseEntity} from '../../../shared/models/ApiModels'
import {TabOption} from '../../../shared/components/FormTabHeader'
import {ICustomerModel, initialCustomer} from './CustomerModel'

export interface IServiceStationModel extends BaseEntity {
  customerType: string
  firstName: string
  lastName: string
  taxOffice?: string
  taxNumber?: string
  tcKimlikNo: number
  country?: string
  city?: string
  district: string
  gsm1: string
  gsm2?: string
  phone?: string
  emailAddress: string
  address: string

  specialCode?: string
  integrationCode?: string
  riskMessage?: string
  riskMessageDate?: string
  riskPermit?: string
  dealerCommissionRate?: string
  partsDiscount?: string
  laborDiscount?: string
  consumablesDiscount?: string
  description?: string

  passive: boolean
  hideInvoiceDetail: boolean
  smsPermission: boolean
  mailPermission: boolean
  phonePermission: boolean
  birthdayTracking: boolean
  customerCardAnonymized: boolean
  rentalCardAnonymized: boolean
  reservationCardAnonymized: boolean
  invoiceCardAnonymized: boolean
  cashboxCardAnonymized: boolean
  trafficHgsCardAnonymized: boolean
}

export const initialServiceStation: IServiceStationModel = {
  customerType: 'SERVICE',
  firstName: '',
  lastName: '',
  taxOffice: '',
  taxNumber: '',
  tcKimlikNo: undefined as unknown as number,
  country: '',
  city: '',
  district: '',
  gsm1: '',
  gsm2: '',
  phone: '',
  emailAddress: '',
  address: '',

  specialCode: '',
  integrationCode: '',
  riskMessage: '',
  riskMessageDate: '',
  riskPermit: '',
  dealerCommissionRate: '',
  partsDiscount: '',
  laborDiscount: '',
  consumablesDiscount: '',
  description: '',

  passive: false,
  hideInvoiceDetail: false,
  smsPermission: false,
  mailPermission: false,
  phonePermission: false,
  birthdayTracking: false,
  customerCardAnonymized: false,
  rentalCardAnonymized: false,
  reservationCardAnonymized: false,
  invoiceCardAnonymized: false,
  cashboxCardAnonymized: false,
  trafficHgsCardAnonymized: false,
}

export const validationServiceStation = Yup.object().shape({
  firstName: Yup.string().required('Firma adı zorunludur'), 
  emailAddress: Yup.string().email('Geçerli bir e-posta girin').required('E-posta zorunludur'),
  gsm1: Yup.string().required('GSM zorunludur'),
  address: Yup.string().required('Adres zorunludur'),
  tcKimlikNo: Yup.mixed().test('tc', 'TC Kimlik No 11 haneli olmalı', (value) => {
    const s = value === null || value === undefined ? '' : String(value)
    if (s === '' || s === '0') return true
    return /^[0-9]{11}$/.test(s)
  }),
  taxOffice: Yup.string().required('Vergi dairesi zorunludur'),
  taxNumber: Yup.string().required('Vergi numarası zorunludur'),
})

export const serviceStationTabs: TabOption<'company' | 'permission'>[] = [
  {key: 'company', title: 'Servis Merkezi Bilgileri', icon: 'bi bi-building'},
  {key: 'permission', title: 'İzinler & Ayarlar', icon: 'bi bi-shield-check'},
]

/** API müşteri DTO; risk alanları CustomerModel’deki yazım (riskMessagge) ile eşlenir */
export function serviceStationToCustomerPayload(values: IServiceStationModel): ICustomerModel {
  return {
    ...initialCustomer,
    ...values,
    riskMessagge: values.riskMessage,
    riskMessaggeDate: values.riskMessageDate,
  } as ICustomerModel
}
